import { API } from "."
import { makeParams } from "@/utils/helper"

import {
  CreatePlayerPayload,
  JoinPlayerPayload,
  ReadAssignablePlayersResponse,
  ReadParticipateActivityParams,
  ReadParticipateActivityResponse,
  ReadPlayerInfoParams,
  ReadPlayerInfoResponse,
  UpsertMovePlayerPayload,
  UpsertPlayerGroupPayload,
  UpsertPlayerPayload,
} from "@/types/player"

/* 호출 시 /teams/{idfTeam} 을 interceptor 에서 추가함 */

/* 선수 계정 생성 및 팀 선수 추가 */
export async function createNewPlayer(payload: CreatePlayerPayload) {
  return await API.post<string>(`/players`, payload)
}

/* 팀 선수 추가 */
export async function joinPlayer(data: { idfPlayer: number; payload: JoinPlayerPayload }) {
  const { idfPlayer, payload } = data
  return await API.post<string>(`/players/${idfPlayer}/join`, payload)
}

/* 기기 등록 가능한 선수 목록 조회 */
export async function readAssignablePlayers() {
  return await API.get<ReadAssignablePlayersResponse>("/players/assignable")
}

/* 선수 정보 조회 */
export async function readPlayerInfo({ idfPlayer, idfActivity }: ReadPlayerInfoParams) {
  const params = makeParams({ idfActivity })

  return await API.get<ReadPlayerInfoResponse>(`/players/${idfPlayer}`, { params })
}

/* 선수 정보 수정 */
export async function upsertPlayer(data: { idfPlayer: number; payload: UpsertPlayerPayload }) {
  const { idfPlayer, payload } = data

  return await API.put<void>(`/players/${idfPlayer}`, payload)
}

/* 선수 정보 수정(기기 정보 포함) */
export async function upsertPlayerWithDevice(data: {
  idfPlayer: number
  payload: UpsertPlayerPayload
}) {
  const { idfPlayer, payload } = data

  return await API.put<void>(`/players/${idfPlayer}/with-device`, payload)
}

/* 선수 방출(삭제) */
export async function upsertPlayerLeave(idfPlayer: number) {
  return await API.put<void>(`/players/${idfPlayer}/leave`)
}

/* 선수 그룹 수정 */
/**
 * @param {Object} data [Required],  { idfPlayer, idfPlayerGroup }
 */
export async function upsertPlayerGroup(data: {
  idfPlayer: string
  payload: UpsertPlayerGroupPayload
}) {
  const { idfPlayer, payload } = data

  return await API.put<void>(`/players/${idfPlayer}/change-group`, payload)
}

/* 선수 팀 이동 */
/**
 * @param {Object} data [Required],  { destIdfTeam, srcIdfTeam, players }
 */
export async function upsertMovePlayers(payload: UpsertMovePlayerPayload) {
  return await API.put<void>(`/players/move-team`, payload)
}

/* 선수가 참여한 액티비티 목록 조회 */
/**
 * @param {number|string|Array} teamList [Required]
 * @param {number|string|Array} playerList [Required]
 * @param {number|string|Date} startTime
 * @param {number|string|Date} endTime
 */
export async function readParticipateActivity({
  idfPlayer,
  start,
  end,
}: ReadParticipateActivityParams) {
  const params = makeParams({ start, end, idfPlayer })

  return await API.get<ReadParticipateActivityResponse>("/players/participate-activities", {
    params,
  })
}
